import React, { useEffect, useState } from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { InstagramEmbed } from "react-social-media-embed";
import LaunchIcon from "@mui/icons-material/Launch";
import InstagramIcon from "@mui/icons-material/Instagram";

const ctaSx = {
  borderRadius: "999px",
  textTransform: "capitalize" as const,
  px: 3,
  py: 1.25,
  background: "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
  boxShadow: "0 8px 24px rgba(18, 53, 36, 0.2)",
  "&:hover": {
    background: "linear-gradient(135deg, #0f2d1f 0%, #1a6b42 100%)",
  },
};

const instagramPosts = [
  "https://www.instagram.com/reel/DGnYjnZBQ6N/?utm_source=ig_embed&amp",
  "https://www.instagram.com/reel/DFp4fBCynZB/?utm_source=ig_embed&amp",
  "https://www.instagram.com/reel/CrAETtJJk_C/?utm_source=ig_embed&amp",
];

const MediaInstagram: React.FC = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <Box sx={{ marginTop: { xs: 0, sm: "1rem" } }}>
      <Container maxWidth="lg" sx={{ textAlign: "center", px: { xs: 2, sm: 3 } }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: 700,
            margin: "2rem auto",
            color: "#123524",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          Featured
          <Box
            component="span"
            sx={{
              color: "#E4405F",
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <InstagramIcon sx={{ fontSize: { xs: "1.75rem", sm: "2rem" } }} />
            Instagram
          </Box>
          posts
        </Typography>

        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            gap: "20px",
            paddingBottom: "10px",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            margin: "auto",
          }}
        >
          {isClient &&
            instagramPosts.map((post, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                style={{
                  maxWidth: "326px",
                }}
              >
                <InstagramEmbed
                  url={post}
                  width="-webkit-fill-available"
                  style={{
                    margin: "auto",
                    maxWidth: "326px",
                  }}
                />
              </motion.div>
            ))}
        </Box>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9 }}
          style={{ marginTop: "20px" }}
        >
          <Button
            variant="contained"
            size="large"
            href="https://www.instagram.com/salon_tym/"
            target="_blank"
            rel="noopener noreferrer"
            endIcon={<LaunchIcon />}
            sx={ctaSx}
          >
            Check out more
          </Button>
        </motion.div>
        <br />
      </Container>
    </Box>
  );
};

export default MediaInstagram;
